export default {
  publishRule () {
    this.show = false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/components/resources/methods.js